<template>
<div>
  <v-container v-if="userIsAuthenticated">
    <v-layout row >
      <v-flex xs12 sm6 offset-sm3>
        <h2>Новая карточка</h2>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <form ref="form" validation @submit.prevent="onCreateMeetup">
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-text-field
                name="name"
                label="Ім'я"
                v-model="name"
                type="text"
                required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-text-field
                name="age"
                label="Возвраст"
                v-model="age"
                type="text"
                required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-text-field
                name="song"
                label="Пісня"
                v-model="song"
                type="text"
                required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-text-field
                name="category"
                label="Категорія працівника"
                v-model="category"
                type="text"
                required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-text-field
                name="youtube"
                label="Лінк на відео"
                type="text"
                multi-line
                v-model="youtube"
                required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-text-field
                name="imageurl"
                label="Лінк на image"
                type="text"
                multi-line
                v-model="imageurl"
                required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-btn
                class="primary"
                :loading="loading"
                :disabled="loading"
                @click="onCreateMeetup"
                >Создать</v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
  <v-layout v-else>
    <v-flex xs12 class="text-xs-center" mt-5>
      <router-link to="/" tag="span" style="cursor: pointer"><v-btn class="a_btn_accept" >Авторизируйтесь</v-btn></router-link>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
  export default {
    data () {
      return {
        name: '',
        age: '',
        song: '',
        category: '',
        youtube: '',
        imageurl: '',
      }
    },
    computed: {
      formIsValid () {
        return this.name !== '' &&
          this.age !== '' &&
          this.song !== '' &&
          this.category !== '' &&
          this.youtube !== '' &&
          this.imageurl !== ''
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    methods: {
      onCreateMeetup () {
        if (!this.formIsValid) {
          return
        }
        const meetupData = {
          name: this.name,
          age: this.age,
          song: this.song,
          category: this.category,
          youtube: this.youtube,
          imageurl: this.imageurl,
          likes: 0
        }
        this.$store.dispatch('createMeetup', meetupData)

      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Meetup/CreateMeetup.vue